import React from "react";
import "./EmptyState.css";

const EmptyState: React.FC = () => {
  return (
    <div className="empty-state">
      <div className="empty-illustration">
        <svg
          width="120"
          height="120"
          viewBox="0 0 120 120"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="120" height="120" rx="60" fill="#F5F7FA" />
          <path
            d="M40 60H80"
            stroke="#C0C4CC"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M60 40V80"
            stroke="#C0C4CC"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      </div>
      <h3>Begin your Chinese name journey!</h3>
    </div>
  );
};

export default EmptyState;
